<template>
  <div class="container">
    <el-card>
      <el-row>
        <el-col :span="8">
          <el-date-picker
            v-model="daterange"
            type="daterange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-input
            placeholder="请输入用户ID"
            v-model="userId"
            size="small"
            clearable>
          </el-input>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button type="primary" size="small" @click="search()">搜索</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="table-title">用户事件明细</div>
      <div style="height: 50px; width: 100%">
        <el-pagination
          layout="prev, pager, next"
          :total="totalCount"
          :page-count="limit"
          v-if="pageShow"
          style="float: right"
          @current-change="changePage">
        </el-pagination>
      </div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column v-for="(col, idx) in tbColumns"
          :key="idx"
          :prop="col.prop"
          :label="col.label"
          :width="col.width">
        </el-table-column>
      </el-table>
    </el-card>
  </div>

</template>
<script>
  import moment from 'moment';
  export default {
    data () {
      return {
        statTypes: ['payment', 'trade', 'receive', 'send'],
        eventTypes: ['created_orders', 'confirmed_orders', 'amount', 'share_amount'],
        userId: '',
        daterange: [],
        tableData: [],
        loading: false,
        totalCount: 0,
        pageShow: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        offset: 0,
        limit: 15,
        tbColumns: [
          { prop: 'date', label: '日期', width: '120'},
          { prop: 'uid', label: '用户ID'},
          { prop: 'last_online', label: '最近上线', width: '180'},
          { prop: 'online_time', label: '在线时长(秒)'},
          { prop: 'match', label: '匹配次数'},
          { prop: 'match_success', label: '匹配成功次数'},
          { prop: 'match_call_success', label: '接通次数'},
          { prop: 'match_call_time', label: '通话时长(秒)'},
          { prop: 'chat_call', label: '主动拨打次数'},
          { prop: 'chat_receive', label: '被动接听次数'},
          { prop: 'chat_success', label: 'Chat接通次数'},
          { prop: 'chat_time', label: 'Chat通话时长(秒)', width: '160'}
        ]
      }
    },
    mounted() {
      let m = moment();
      let e = m.format('YYYY-MM-DD');
      let s = m.subtract(7, 'days').format('YYYY-MM-DD');
      this.daterange = [s, e];
      this.search(0);
    },
    methods: {
      changePage(val) {
        let offset = (val - 1) * this.limit;
        this.search(offset);
      },
      search(offset) {
        offset = offset || 0;

        let dr = this.daterange;

        if (this.userId && isNaN(this.userId)) {
          this.$notify({
            title: '警告',
            message: '用户ID格式错误',
            type: 'warning'
          });
          return
        }
        let start = (dr && dr.length > 0) ? dr[0]: undefined
        let end = (dr && dr.length > 0) ? dr[1]: undefined

        this.getBehaviorData(start, end, this.userId, offset);
      },
      async getBehaviorData(start, end, uid, offset) {

        this.loading = true;
        try {
          this.pageShow = offset != 0

          let url = `/bi-tira/tira/behavior/stat/list?offset=${offset || this.offset}&limit=${this.limit}`;

          if (start) {
            url += `&start=${start}&end=${end}`
          }
          if (uid) {
            url += `&uid=${uid}`
          }

          let rst = await this.$http.get(url);

          let data = rst.data.data;

          data.forEach((d) => {
            d.date = d.date.split('T')[0];
            d.last_online = moment(d.last_online * 1000).format('YYYY-MM-DD HH:mm:ss');
          })

          this.tableData = data;
          this.totalCount = rst.data.total;

          this.pageShow = true;
        } finally {
          this.loading = false;
        }

      }
    }
  }
</script>
<style lang="less" scoped>

  .container {
    padding: 20px;
  }

  .table-title {
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 15px 0;
  }
</style>
